import React, { useContext } from 'react';
import { LanguageContext } from '@/context/LanguageContext';
import LanguageSelectionDialog from './LanguageSelectionDialog';
import WelcomeDialog from './WelcomeDialog';

/**
 * Wrapper component for language-related dialogs
 * This ensures dialogs are rendered after LanguageProvider is fully initialized
 */
const LanguageDialogs = () => {
  // Check if context is available before rendering children
  const context = useContext(LanguageContext);
  
  // Don't render dialogs if context isn't ready yet
  if (!context) {
    return null;
  }

  return (
    <>
      <LanguageSelectionDialog />
      <WelcomeDialog />
    </>
  );
};

export default LanguageDialogs;
